/* renders surveys page */
import React from 'react';
import MainLayout from '../utilities/layouts/MainLayout';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CardItem, CardList, EmptyItem, MobileHomeButton } from '../utilities/commonUtilities/CardItem';
import { ReactComponent as SymptomImage } from '../../resources/images/symptom-badge.svg';
import { PageTitleBlock } from '../utilities/commonUtilities/GenericDivElements';
import { Typography } from '@material-ui/core';
import { ReactComponent as SurveysEmpty } from '../../resources/images/survey-empty.svg';
import { PATH_SURVEY_RESPONSES } from '../../containers/RoutePaths';
import SurveyResponseLoader from './SurveyResponseLoader';

const SurveysPage = ({ completedSurveys = [] }) => {
    return (
        <>
            <MainLayout>
                <SurveyResponseLoader>
                    {completedSurveys.length > 0 && (
                        <PageTitleBlock>
                            <Typography variant="h1">Surveys</Typography>
                        </PageTitleBlock>
                    )}
                    <CompletedSurveyCards completedSurveys={completedSurveys} />
                </SurveyResponseLoader>
            </MainLayout>
            {completedSurveys.length === 0 && <MobileHomeButton />}
        </>
    );
};

function CompletedSurveyCards({ completedSurveys = [] }) {
    return completedSurveys.length > 0 ? (
        <CardList>
            {completedSurveys.map(item => {
                return <SurveyCard key={item.id} survey={item} />;
            })}
        </CardList>
    ) : (
        <EmptyItem image={SurveysEmpty} title="No Surveys Found" message="Your completed surveys will show up here." />
    );
}

function SurveyCard({ survey }) {
    const history = useHistory();
    return (
        <CardItem
            Badge={SymptomImage}
            title="Wellness Survey"
            subtitle={`Completed on ${survey.authored}`}
            onClick={() => handleCardClick(survey.id, history)}
        />
    );
}

function handleCardClick(surveyId, history) {
    history.push({
        pathname: PATH_SURVEY_RESPONSES.concat(surveyId),
    });
}

const mapStateToProps = props => {
    return {
        completedSurveys: props.completedSurveys.surveys,
    };
};

export default connect(mapStateToProps)(SurveysPage);
